import DateSelectModalContent from './DateSelectModalContent';

export default DateSelectModalContent;
